// FOYR-431 — the PreOrder guest service now lives inside pay-at-table-backend.
// Every call goes to the pat api host for the environment, under the URI-
// versioned prefix `/v1/preorder`. The three hosts below are the pat api
// hostnames (pat-infra/docs/inventory.md); the old `api.cassionova.com` /
// `dev.glydegateway.com` targets are the retired standalone service.
export class URLConstant {
  // Manual environment flags: toggle PROD true/false as needed
  PROD = false; // set true for production; sed'd per branch in CI
  DEV = true; // optional mirror flag
  DEMO = true; // set true for demo builds; sed'd per branch in CI

  // Base hosts — the pay-at-table api per environment (env-as-zone).
  url_prod = "https://api.foyrpay.com";
  url_dev = "https://api.dev.foyrpay.com";
  // url_dev = "http://localhost:8080";
  url_demo = "https://api.demo.foyrpay.com";

  // Final base URL for API.
  //
  // A non-empty `REACT_APP_API_BASE_URL` wins over the branch flags, so a
  // local build can be pointed at a local backend (`REACT_APP_API_BASE_URL=
  // http://localhost:8080 npm start`). CRA inlines `REACT_APP_*` at build
  // time and CI never sets this one — it only `sed`s the flags below — so
  // every deployed bundle resolves through the ternary exactly as before.
  get url(): string {
    const override = process.env.REACT_APP_API_BASE_URL?.trim();
    if (override) return override.replace(/\/+$/, "");
    return this.DEMO ? this.url_demo : this.PROD ? this.url_prod : this.url_dev;
  }

  get environment(): "PRODUCTION" | "TEST" {
    return this.PROD ? "PRODUCTION" : "TEST";
  }

  // Grouped endpoints used by this app (the nine FOYR-431 routes minus the
  // webhook, which is OpenTable's). Paths per the FOYR-431 route map:
  //   POST /reservation/:id/otp       (was POST /generateOTP/:id)
  //   POST /otp/verify                (was POST /verifyOTP)
  //   POST /reservation/:id/order     (was POST /updateOrder/:id — appends)
  //   PUT  /reservation/:id/order     (was PUT  /editOrder/:id  — replaces)
  // `modifications/byIds` was not ported (modifiers are out of the product);
  // see restaurant.service.ts.
  get PREORDER() {
    const base = `${this.url}/v1/preorder`;
    return {
      BASE: base,
      generateOTP: (reservationId: string) =>
        `${base}/reservation/${encodeURIComponent(reservationId)}/otp`,
      verifyOTP: `${base}/otp/verify`,
      updateOrder: (reservationId: string) =>
        `${base}/reservation/${encodeURIComponent(reservationId)}/order`,
      editOrder: (reservationId: string) =>
        `${base}/reservation/${encodeURIComponent(reservationId)}/order`,
      reservation: (reservationId: string) =>
        `${base}/reservation/${encodeURIComponent(reservationId)}`,
      reservationCalendar: (reservationId: string) =>
        `${base}/reservation/${encodeURIComponent(reservationId)}/calendar.ics`,
      restaurant: (restaurantId: string, reservationId: string) =>
        `${base}/restaurant/${encodeURIComponent(
          restaurantId,
        )}/${encodeURIComponent(reservationId)}`,
    } as const;
  }
}

const urls = new URLConstant();
export default urls;
